import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Publicar() {
  const [form, setForm] = useState({
    category: "",
    title: "",
    country: "",
    description: "",
    highlights: [""],
    askingPrice: "",
    ttmRevenue: "",
    ttmProfit: "",
    lastMonthRevenue: "",
    lastMonthProfit: "",
    founded: "",
    teamSize: "",
    businessModel: "",
    services: "",
    techStack: [""],
    competitors: [""],
    growthOpportunities: [""],
    assets: [""],
    reasoning: [""],
    financing: ""
  });

  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  const handleArrayChange = (field, index, value) => {
    const updated = [...form[field]];
    updated[index] = value;
    setForm({ ...form, [field]: updated });
  };


  const addArrayItem = (field) => {
    setForm({ ...form, [field]: [...form[field], ""] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowPopup(true);
    console.log("Empresa subida:", form);
  };

  return (
    <div className="min-h-screen w-full bg-gray-50 py-12 px-4 sm:px-6 lg:px-16 relative">
      {showPopup && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
          <div className="bg-white rounded-xl shadow-xl p-8 text-center max-w-md w-full animate-fade-in">
            <img src="/noltrade_gpt.png" alt="Noltrade Logo" className="mx-auto h-10 mb-4" />
            <h2 className="text-lg font-semibold text-gray-800 mb-2">Tu oferta se ha enviado</h2>
            <p className="text-sm text-gray-600 mb-2">
              Validaremos tu oferta en un plazo máximo de <strong>24 horas</strong>.
            </p>
            <p className="text-sm text-gray-600 mb-6">
              Cuando se valide, se te notificará por correo electrónico.
            </p>
            <p className="text-sm text-gray-600 mb-6">
              Gracias por confiar en Noltrade.
            </p>
            <button
                onClick={() => navigate("/")}
                className="bg-yellow-500 hover:bg-yellow-600 text-white px-6 py-2 rounded"
                >
                Cerrar
        </button>

          </div>
        </div>
      )}

      <div className="w-full bg-white rounded-xl shadow-md p-10">
        <h1 className="text-3xl font-bold mb-10 text-gray-800">Publicar empresa en venta</h1>

        <form onSubmit={handleSubmit} className="space-y-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <input type="text" placeholder="Título del negocio" className="border p-3 rounded" value={form.title} onChange={(e) => handleChange("title", e.target.value)} />
            <input type="text" placeholder="País" className="border p-3 rounded" value={form.country} onChange={(e) => handleChange("country", e.target.value)} />

            <select className="border p-3 rounded" value={form.category} onChange={(e) => handleChange("category", e.target.value)}>
              <option value="">Selecciona categoría</option>
              <option value="SaaS">SaaS</option>
              <option value="Agencia">Agencia</option>
              <option value="Startup">Startup</option>
              <option value="Restaurante">Restaurante</option>
              <option value="Bar">Bar</option>
              <option value="Tienda">Tienda</option>
            </select>

            <input type="text" placeholder="Año de fundación" className="border p-3 rounded" value={form.founded} onChange={(e) => handleChange("founded", e.target.value)} />
          </div>

          <textarea placeholder="Descripción" className="border p-3 rounded w-full" rows={4} value={form.description} onChange={(e) => handleChange("description", e.target.value)} />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <input type="text" placeholder="Ingresos últimos 12m" className="border p-3 rounded" value={form.ttmRevenue} onChange={(e) => handleChange("ttmRevenue", e.target.value)} />
            <input type="text" placeholder="Beneficio últimos 12m" className="border p-3 rounded" value={form.ttmProfit} onChange={(e) => handleChange("ttmProfit", e.target.value)} />
            <input type="text" placeholder="Precio pedido" className="border p-3 rounded" value={form.askingPrice} onChange={(e) => handleChange("askingPrice", e.target.value)} />
            <input type="text" placeholder="Ingresos mes pasado" className="border p-3 rounded" value={form.lastMonthRevenue} onChange={(e) => handleChange("lastMonthRevenue", e.target.value)} />
            <input type="text" placeholder="Beneficio mes pasado" className="border p-3 rounded" value={form.lastMonthProfit} onChange={(e) => handleChange("lastMonthProfit", e.target.value)} />
            <input type="text" placeholder="Tamaño del equipo" className="border p-3 rounded" value={form.teamSize} onChange={(e) => handleChange("teamSize", e.target.value)} />
          </div>

          <select className="border p-3 rounded w-full" value={form.businessModel} onChange={(e) => handleChange("businessModel", e.target.value)}>
            <option value="">Modelo de negocio</option>
            <option value="B2B">B2B</option>
            <option value="B2C">B2C</option>
            <option value="Suscripción">Suscripción</option>
            <option value="Marketplace">Marketplace</option>
          </select>

          <input type="text" placeholder="Servicios que ofrece el negocio" className="border p-3 rounded w-full" value={form.services} onChange={(e) => handleChange("services", e.target.value)} />

          {["highlights", "techStack", "competitors", "growthOpportunities", "assets", "reasoning"].map((field) => (
            <div key={field}>
              <label className="font-semibold text-sm text-gray-700 mb-2 block capitalize">
                {field.replace(/([A-Z])/g, " $1")}:
              </label>
              {form[field].map((val, idx) => (
                <input
                  key={idx}
                  type="text"
                  placeholder={`Item ${idx + 1}`}
                  className="border p-2 rounded w-full mb-2"
                  value={val}
                  onChange={(e) => handleArrayChange(field, idx, e.target.value)}
                />
              ))}
              <button type="button" onClick={() => addArrayItem(field)} className="text-xs text-blue-600 hover:underline">
                + Añadir otro
              </button>
            </div>
          ))}

          <select className="border p-3 rounded w-full" value={form.financing} onChange={(e) => handleChange("financing", e.target.value)}>
            <option value="">Financiación</option>
            <option value="Bootstrapped">Bootstrapped</option>
            <option value="Inversión externa">Inversión externa</option>
            <option value="No aplica">No aplica</option>
          </select>

          <button type="submit" className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-6 py-3 rounded transition">
            Publicar oferta
          </button>
        </form>
      </div>
    </div>
  );
}
